import PropTypes from 'prop-types';

export const adminAccessProductsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
  })
);

export const addressProps = {
  addressLine1: PropTypes.string,
  addressLine2: PropTypes.string,
  city: PropTypes.string,
  stateOrProvince: PropTypes.string,
  postalCode: PropTypes.string,
  country: PropTypes.string,
};

export const projectDataShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  startDate: PropTypes.string,
  jobNumber: PropTypes.string,
  projectValue: PropTypes.shape({
    currency: PropTypes.string,
    value: PropTypes.number,
  }),
  timezone: PropTypes.string,
  ...addressProps,
});
